module.exports = __webpack_public_path__ + "static/media/divasIndogtags_small.25d28c8a.jpeg";